<template>
    <div id="UsersList">
        <b-container>
            <b-table
                id="listTable"
                :key="myKey"
                selectable
                :items="items"
                :fields="fields"
                :per-page=0
                :current-page="curPage"
                striped
                :select-mode="selectMode"
                head-row-variant="info"
                selected-variant=""
                @row-selected="onRowSelected"
            >
                <template v-slot:cell(avatar)="data">
                    <div v-if="data.item.avatarUrl!=''">
                        <b-avatar :src="data.item.avatarUrl" size="2em"></b-avatar>
                    </div>
                </template>
                <template v-slot:cell(userName)="data">
                    <div class="itsBkg" v-if="data.item.userName == userName">
                        {{ userName }}
                    </div>
                    <div v-else>
                        {{ data.item.userName }}
                    </div>
                </template>
                </b-table>

                <b-pagination
                        v-model="curPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="listTable"
                ></b-pagination>

                <br><br><br>

        </b-container>

        <b-container fluid class="footer text-center">
            <span class="tblName">{{ tblName }}</span>
        </b-container>
        <b-container fluid class="footer text-center"> &nbsp;&nbsp;&nbsp;
            <b-form-group>
                <b-form-radio-group id="rg" v-model="selected" name="radio-sub-component">
                    <b-form-radio name="some-radios" value="markIt">
                        <font-awesome-icon icon="thumbtack" size="lg" :style="{ color: 'white' }" />
                    </b-form-radio>
                    <b-form-radio name="some-radios" value="User">
                        <font-awesome-icon icon="eye" size="lg" :style="{ color: 'white' }" />
                    </b-form-radio>
                    <b-form-radio name="some-radios" value="block" v-if="blocked!='true'">
                        <font-awesome-icon icon="lock" size="lg" :style="{ color: 'white' }" />
                    </b-form-radio>
                    <b-form-radio name="some-radios" value="unBlock" v-if="blocked==='true'">
                        <font-awesome-icon icon="lock-open" size="lg" :style="{ color: 'white' }" />
                    </b-form-radio>
                    <b-form-radio name="some-radios" value="delete">
                        <font-awesome-icon icon="trash-alt" size="lg" :style="{ color: 'white' }" />
                    </b-form-radio>
                </b-form-radio-group>
            </b-form-group>
        </b-container>

            <b-modal id="modalConf1" ref="modalConf1">
                <div class="d-block text-center">
                    <h4>{{this.$t('SURE')}}</h4>
                </div>
                <template v-slot:modal-footer="">
                    <b-button variant="success" @click="$bvModal.hide('modalConf1')">{{$t('CANCEL')}}</b-button>
                    <b-button variant="danger" @click="deleteUser()">{{$t('GO_ON')}}</b-button>
                </template>
            </b-modal>

    </div>

</template>

<script>
import { BContainer, BTable, BPagination, BAvatar, BFormGroup, BFormRadio, BFormRadioGroup, BModal, BButton } from 'bootstrap-vue';

export default {
  name: 'UsersList',
  components: {
    BContainer, BTable, BPagination, BAvatar, BFormGroup, BFormRadio, BFormRadioGroup, BModal, BButton
  },
  data: function() {
    return {
        selectedUser: '',
        fields: [
          {
            key: 'userName',
            label: this.$t('USER'),
            sortable: true
          },
          {
            key: 'numPubItems',
            label: this.$t('PUB'),
            sortable: true
          },
          {
            key: 'avatar',
            label: 'Avatar',
            sortable: false
          }
        ],
        items: [{}],
        tblName: '',
        listLoc: this.$i18n.locale,
        item: {},
        selected: 'markIt',
        myKey: 0,
        perPage: 10,
        curPage: 1,
        curLang: '',
        listLength: 0,
        blocked: '',
        selectMode: 'single',
        userName: ''
    }
  },
  mounted() {
    this.$bvModal.hide('modalConf1');
    if(this.$store.state.curUserName!='admin') this.$showErr(this.$t('TMOUT'), 401);
    this.blocked = this.$route.query.blocked;
    this.getUsersList();
  },
  methods: {
    async getUsersList() {
        try {
            const response = await this.$http.get('getUsersList', {
                params: {
                    pageNum: this.curPage,
                    blocked: this.blocked
                }
            });
            this.items = response.data.itemList;
            if(this.items.length == 0) {
                this.$showMsg(this.$t('EMPTY_LIST'));
                this.$router.go(-1);
            }
            else {
                this.curPage = response.data.pageNum;
                this.listLength = response.data.listLen;
            }
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    onRowSelected(items) {
        this.item = items[0];
        this.userName = this.item.userName;
        this.myKey++;
        this.selectedUser = this.item.userName;
        this.$store.commit('setUserName', this.selectedUser);
        if(this.selected==='User') {
            this.$router.push({
               path: 'User',
               query: {
                  userName: this.$addEncHyp(this.selectedUser)
                }
            })
        }
        if(this.selected==='markIt') {
            this.$store.commit('setUserName', this.selectedUser);
        }
/*
        if(this.selected==='block') {

        }
        if(this.selected==='unBlock') {

        }
*/
        if(this.selected==='delete') {
            this.$bvModal.show('modalConf1');
        }
    },
    async deleteUser() {
        if(this.selectedUser === 'admin') {
            this.$showMsg(this.$t('PROHIBIT'));
            return;
        }
        try {
            await this.$http.get('deleteUser', {
                params: {
                    userName: this.selectedUser
                }
            });
            this.$bvModal.hide('modalConf1');
            this.$showMsg(this.$t('DONE'));
            this.getUsersList();
            this.selected = 'markIt';
       }
       catch(error) {
            this.$showErr(error.response.data, error.response.status);
       }
    }
  },
  watch: {
      '$store.state.intLoc': function() {
        this.intLoc = this.$store.state.intLoc;
        //this.reloadList();
      },
      curPage: function(value) {
        this.getUsersList(value);
      },
      curLang: function() {
        //alert(this.$i18n.locale);
      }
  },
  computed: {
    rows() {
        return this.listLength;
    }
  }
}

</script>

<style>
    #rg{
        color: white;
    }
    .tblName{
        color: white;
    }
</style>
